export default __webpack_public_path__ + "static/media/Welcome-to-Member-Online-Header-Banner_640x300.d62e0d25.jpg";